import BookingOverviewContainer from "../../container/admin/bookingOverview/bookingOverviewContainer";
import BookingOverviewProvider from "../../container/admin/bookingOverview/context/bookingOverviewContext";

const BookingOverview = (): React.JSX.Element => (
  <BookingOverviewProvider>
    <BookingOverviewContainer />
  </BookingOverviewProvider>
);

export default BookingOverview;
